import { useState } from "react";
import Tab0helperView from "../components/features/Tab0helperView";
import Tab1helperView from "../components/features/Tab1helperView";
import Tab2helperView from "../components/features/Tab2helperView";
import UnlockScreen from "../components/features/UnlockScreen";

function Helper() {
    const [pendingHelp, setPendingHelp] = useState([]);
    const [currentlyHelping, setCurrentlyHelping] = useState([]);
    const [currentTab, setCurrentTab] = useState(0);
    const [access, setAccess] = useState(false);
    const [loading, setLoading] = useState(false);

    return (
        <main>
            {
                access ?
                <>
                    <div className="loading" style={{display: loading ? "block" : "none"}} />
                    <div id="tabs-container-helper-page">
                        <p onClick={() => {setCurrentTab(0)}} style={{textDecoration: (currentTab===0 ? "underline" : "none")}}>Hjelp tilkallelser</p>
                        <p onClick={() => {setCurrentTab(1)}} style={{textDecoration: (currentTab===1 ? "underline" : "none")}}>Deaktiver QR-koder</p>
                        <p onClick={() => {setCurrentTab(2)}} style={{textDecoration: (currentTab===2 ? "underline" : "none")}}>Timeout brukere</p>
                    </div>
                    {currentTab===0 ? <Tab0helperView setLoading={setLoading} setPendingHelp={setPendingHelp} setCurrentlyHelping={setCurrentlyHelping} currentlyHelping={currentlyHelping} pendingHelp={pendingHelp} /> : ""}
                    {currentTab===1 ? <Tab1helperView /> : ""}
                    {currentTab===2 ? <Tab2helperView ids={[...(currentlyHelping.map(req => req.userID)), ...(pendingHelp.map(req => req.userID))]} /> : ""}
                    <a href="/qr-kode-oversikt" style={{position: "absolute", bottom: "3px", right: "3px", opacity: "0.4", zIndex: "1"}}>Lag QR-koder</a>
                </>
                :
                <UnlockScreen setAccess={setAccess} />
            }
            
        </main>
    );
};

export default Helper;